import {Outlet} from 'react-router-dom';

import Header from '@common/layout/Header';
import Footer from '@common/layout/Footer';

import HeaderMenu from '@common/components/HeaderMenu';
import CompositionBreadcrumb from '@modules/piu/features/compositionSheet/components/CompositionBreadcrumb';

const CompositionSheetLayout = () => {
  return (
    <div className="w-full h-full min-h-screen flex flex-col relative pb-10">
      <Header breadcrumbs={<CompositionBreadcrumb />}>
        <HeaderMenu />
      </Header>
      <Outlet />
      <Footer />
    </div>
  );
};

export default CompositionSheetLayout;
